<template>
  <section class="luxury-gallery-section">
    <div class="container">
      <div class="gallery-luxury-header">
        <div class="gallery-luxury-badge">
          <i :class="headerData.icon"></i>
          <span>{{ headerData.tag }}</span>
        </div>
        <h2>{{ headerData.title }}</h2>
        <p class="gallery-luxury-subtitle">{{ headerData.description }}</p>
      </div>
      
      <div class="luxury-gallery-grid">
        <div class="gallery-luxury-item" v-for="(item, index) in luxuryGallery" :key="index">
          <div class="gallery-luxury-image">
            <img :src="item.image" :alt="item.title" />
            <div class="gallery-luxury-overlay">
              <div class="overlay-luxury-content">
                <h3>{{ item.title }}</h3>
                <div class="luxury-stats">
                  <div class="luxury-stat">
                    <span class="luxury-stat-value">{{ item.stats[0].value }}</span>
                    <span class="luxury-stat-label">{{ item.stats[0].label }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ServiceItsCardGalleryComp",
  props: {
    headerData: {
      type: Object,
      required: true,
      default: () => ({
        icon: "fas fa-gem",
        tag: "LUXURY GALLERY",
        title: "Exclusive Service Gallery",
        description: "Witness the transformation of luxury vehicles through our premium services"
      })
    },
    luxuryGallery: {
      type: Array,
      required: true,
      default: () => []
    }
  }
};
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Import Flaticon */
@import '@/assets/scss/Flaticon.scss';

/* Luxury Gallery Section */
.luxury-gallery-section {
  padding: 120px 0;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  color: white;
}

.gallery-luxury-header {
  text-align: center;
  margin-bottom: 70px;
}

.gallery-luxury-badge {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: linear-gradient(135deg, #d4af37, #b8860b);
  color: #1a1a1a;
  padding: 12px 30px;
  border-radius: 35px;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin-bottom: 30px;
  box-shadow: 0 8px 20px rgba(212, 175, 55, 0.3);
}

.gallery-luxury-header h2 {
  font-size: 54px;
  font-weight: 800;
  color: white;
  margin-bottom: 25px;
  font-family: 'Archivo', sans-serif;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.gallery-luxury-subtitle {
  font-size: 22px;
  color: rgba(255, 255, 255, 0.8);
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;
}

.luxury-gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
  margin-top: 70px;
}

.gallery-luxury-item {
  position: relative;
  border-radius: 25px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(212, 175, 55, 0.2);
}

.gallery-luxury-item:hover {
  transform: translateY(-20px) scale(1.03);
  box-shadow: 0 35px 70px rgba(212, 175, 55, 0.3);
  border-color: #d4af37;
}

.gallery-luxury-image {
  position: relative;
  overflow: hidden;
  height: 300px;
}

.gallery-luxury-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.gallery-luxury-item:hover .gallery-luxury-image img {
  transform: scale(1.1);
}

.gallery-luxury-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(212, 175, 55, 0.95), rgba(184, 134, 11, 0.95));
  color: #1a1a1a;
  padding: 40px 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(20px);
}

.gallery-luxury-item:hover .gallery-luxury-overlay {
  opacity: 1;
}

.overlay-luxury-content {
  text-align: center;
  transform: translateY(20px);
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.gallery-luxury-item:hover .overlay-luxury-content {
  transform: translateY(0);
}

.overlay-luxury-content h3 {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
  color: #1a1a1a;
}

.luxury-stats {
  display: flex;
  justify-content: center;
  gap: 30px;
  flex-wrap: wrap;
}

.luxury-stat {
  text-align: center;
}

.luxury-stat-value {
  display: block;
  font-size: 32px;
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 8px;
  font-family: 'Archivo', sans-serif;
}

.luxury-stat-label {
  font-size: 14px;
  color: rgba(26, 26, 26, 0.8);
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 600;
}

/* Responsive Design */
@media (max-width: 768px) {
  .luxury-gallery-grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .gallery-luxury-header h2 {
    font-size: 42px;
  }
  
  .gallery-luxury-subtitle {
    font-size: 18px;
  }
  
  .gallery-luxury-image {
    height: 250px;
  }
  
  .overlay-luxury-content h3 {
    font-size: 24px;
  }
  
  .luxury-stat-value {
    font-size: 28px;
  }
}

@media (max-width: 480px) {
  .gallery-luxury-image {
    height: 200px;
  }
  
  .gallery-luxury-overlay {
    padding: 30px 20px;
  }
  
  .overlay-luxury-content h3 {
    font-size: 20px;
  }
  
  .luxury-stat-value {
    font-size: 24px;
  }
}
</style>
